export default "__VITE_ASSET__CtMWKIq3__"